import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Container, Image } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";

const Guideline = () => {
	async function getGuideline(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/guideline").then((r)=>r.json().then((json)=>{
            return json
        }))
    }

    const location = useLocation()
	const [guideline,setGuideline] = useState("")

	useEffect(() => {
		document.querySelector("title").textContent = "ガイドライン - アワートAI"
		getGuideline().then(r=>{
			if(r.result){
				setGuideline(r.text)
			}
		})
	},[location.pathname])

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Container className='w-100' dangerouslySetInnerHTML={{__html: guideline}} />
        <Footer />
    </div>
    )
}

export default Guideline;
